import React, { useEffect } from "react";
import './../styles/ecom.css';
import './../styles/ecom/sobre-mi.css';
import NavbarTop from './ecom/Navbartop';
import Footer from './ecom/Footer';
import * as globals from './../components/GlobalScripts.js';

import banner1 from './../components/sobre-mi.webp';
import imgView from './../components/sobre-mi-view.webp';

const Sobre_mi = () => {

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, []);

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-sobremi">
                <div className="slider">
                    <div className="slide" style={{ backgroundImage: `url(${banner1})` }}>
                        <div className='overlay-slider'></div>
                        <div className="content">
                            <h1>Zagriman</h1>
                            <p>El héroe que los animales necesitaban...</p>
                        </div>
                    </div>
                </div>
                <div className="page-container">
                    <div className='container-section medium-section flex-column center gap-20 banner black'>
                        <h1 className="center no-margin">Mi Historia</h1>

                        <img className="portada" src={imgView} alt="Zadrigman con Taquito" loading="lazy" />

                        <p className="center no-margin">
                            En un día marcado por la pérdida y el dolor, el 11 de mayo de 2021, nació Zadrigman.<br /><br />
                            Tras despedirse de su mejor amigo Duke, un noble perrito que luchó contra una enfermedad difícil, Zadrigman decidió convertir el dolor en propósito.<br />
                            Hizo una promesa: dedicar su vida a proteger y ayudar a los animales que más lo necesitan.<br />
                            Aunque Duke ya no está, su espíritu vive en cada rescate, en cada sonrisa lograda, y en cada vida salvada.<br /><br />
                            Así nació el héroe que hoy inspira a muchos con un mensaje claro: nadie está solo cuando hay esperanza y valentía.
                        </p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Sobre_mi;
